import { Component, Input, OnInit } from '@angular/core';
import {
	capitalizeFirstLetter,
	enumAsSelectOptions,
	isNotNuloOuUndefined,
	numberToBrNumber,
} from '@utils';
import { RelatorioNDCResponse } from '../../interfaces/relatorio-ndc';
import { corrigeDuplicacaoNome } from '../../utils';
import { AgrupamentoEspecial } from '../../interfaces';

@Component({
	selector: 'seira-popup-ndc',
	templateUrl: './popup-ndc.component.html',
	styleUrls: ['./popup-ndc.component.scss'],
})
export class PopupNdcComponent implements OnInit {
	@Input() ndc?: RelatorioNDCResponse;
	@Input() headerColor = 'bg-primary';
	@Input() titleColor = 'white';
	@Input() agrupamento: string;

	protected readonly isNotNuloOuUndefined = isNotNuloOuUndefined;
	protected readonly numberToBrNumber = numberToBrNumber;
	protected readonly capitalizeFirstLetter = capitalizeFirstLetter;
	nome: string;
	labelDiasComChuva!: string;
	deveMostrarDiasComChuva!: boolean;

	ngOnInit() {
		this.nome = corrigeDuplicacaoNome(this.nome);
		this.deveMostrarDiasComChuva = this.getDeveMostrarDiasComChuva();
		this.labelDiasComChuva = this.getLabelDiasComChuva();
	}

	get generoAgrupamento(): string {
		return ['MUNICIPIO_POSTO', 'MUNICIPIO'].includes(this.agrupamento)
			? 'o'
			: 'a';
	}

	private getLabelDiasComChuva(): string {
		return this.deveMostrarDiasComChuva
			? this.ndc!.diasComChuva === 1
				? this.ndc!.diasComChuva + ' dia'
				: this.ndc!.diasComChuva + ' dias'
			: [
					'Sem medições para',
					this.generoAgrupamento,
					this.labelTipoAgrupamento,
					'nesse período.',
			  ].join(' ');
	}

	private getDeveMostrarDiasComChuva(): boolean {
		return (
			isNotNuloOuUndefined(this.ndc) &&
			isNotNuloOuUndefined(this.ndc.diasComChuva)
		);
	}

	get labelTipoAgrupamento(): string {
		return enumAsSelectOptions<string>(AgrupamentoEspecial)
			.find(e => e.value === this.agrupamento)!
			.name!.toLowerCase();
	}
}
